export const LHVIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <rect width="48" height="48" rx="4" fill="#F5F6F8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0031 19L24.4112 23.0152H21.1117L21.7184 19H17.4867V27.5303H13.048L14.3056 19H10V29H20.2388L20.8898 24.4697H24.2041L23.5383 29H27.0005L28.4061 20.4697L31.4985 29H34.5612L39 19H36.6179L34.3837 24.2576L34.1321 24.8939L33.8954 24.2576L31.9571 19H25.0031Z"
        fill="#191817"
      />
    </svg>
  );
};
